module.exports = __webpack_public_path__ + "static/img/IMG_20160922_214021.76bc5a5e.jpg";